import Affirmation from "./Affirmation";

export default Affirmation;
